export default __webpack_public_path__ + "static/media/gateway-white.1c376736.png";